const ALLOWED_LINK_SCHEMES = new Set(["http:", "https:", "mailto:", "tel:"]);

/** Splits a links cell on semicolons/newlines without altering entries. */
export function splitLinksField(value: unknown): string[] {
  return String(value ?? "")
    .split(/[;\n]+/)
    .map((part) => part.trim())
    .filter(Boolean);
}

/**
 * Parses a links cell into safe absolute URLs. Bare hosts get `https://`;
 * anything that is not http(s)/mailto/tel (e.g. `javascript:`) is dropped.
 */
export function parseLinks(value: unknown): string[] {
  if (!value) return [];
  return String(value)
    .split(/[\n;,]+/)
    .map((part) => part.trim())
    .filter(Boolean)
    .map((url) => (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(url) ? url : `https://${url}`))
    .filter((url) => {
      try {
        return ALLOWED_LINK_SCHEMES.has(new URL(url).protocol);
      } catch {
        return false;
      }
    });
}

/** Reads the links cell under any of its historical column names. */
export function getLinksCell(row: Record<string, unknown>): unknown {
  return row.links ?? row.Links ?? row.Kildeliste;
}
